import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useI18n } from "../i18n/I18nProvider";
import LanguageSwitcher from "./LanguageSwitcher";

const Navbar = () => {
  const location = useLocation();
  const { t } = useI18n();

  const navItems = [
    { path: "/", key: "nav.home" },
    { path: "/about", key: "nav.about" },
    { path: "/portfolio", key: "nav.portfolio" },
    { path: "/blog", key: "nav.blog" },
    { path: "/contact", key: "nav.contact" },
  ];

  const waText = t("whatsapp.prefill");

  const socials = [
    {
      icon: "fa-facebook",
      link: "https://www.facebook.com/hasnaoui1993/",
    },
    {
      icon: "fa-instagram",
      link: "https://www.instagram.com/abdenacer_hasnaoui/",
    },
    {
      icon: "fa-github",
      link: "https://github.com/abdenacer1993",
    },
    {
      icon: "fa-linkedin",
      link: "https://www.linkedin.com/in/abdenacer-hasnaoui-91bb86211/",
    },
    {
      icon: "fa-whatsapp",
      link: `https://wa.me/21624587616?text=${encodeURIComponent(waText)}`,
    },
  ];

  return (
    <div>
      <div className="header_section">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="logo">
              <Link to="/">
                <img src="/images/logo.png" alt="" />
              </Link>
            </div>
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label={t("nav.toggle")}
            >
              <span className="navbar-toggler-icon" />
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav ml-auto align-items-lg-center flex-wrap">
                {navItems.map((item, index) => (
                  <li key={index} className="nav-item">
                    <NavLink
                      end={item.path === "/"}
                      className={({ isActive }) =>
                        "nav-link" + (isActive ? " nav-link--active" : "")
                      }
                      to={item.path}
                    >
                      {t(item.key)}
                    </NavLink>
                  </li>
                ))}
                <li className="nav-item nav-item--lang d-flex align-items-center">
                  <LanguageSwitcher />
                </li>
              </ul>
            </div>
          </nav>
        </div>

        {location.pathname === "/" && (
          <div className="banner_section layout_padding pro-hero-modern">
            <div className="container position-relative">
              <div className="pro-hero-grid">
                <div className="pro-hero-content">
                  <span className="pro-hero-badge">{t("hero.tagline")}</span>
                  <p className="pro-hero-hello banner_text">{t("hero.hello")}</p>
                  <h1 className="banner_taital pro-hero-name">{t("hero.name")}</h1>
                  <p className="pro-hero-role">{t("hero.role")}</p>
                  <div className="social_icon pro-hero-social">
                    <ul>
                      {socials.map((social, i) => (
                        <li key={i}>
                          <a
                            href={social.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i
                              className={`fa ${social.icon}`}
                              aria-hidden="true"
                            />
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="pro-hero-visual">
                  <div className="pro-hero-portrait-ring" aria-hidden />
                  <div className="pro-hero-portrait-frame">
                    <img
                      src="/images/hero-portrait.png"
                      alt=""
                      className="pro-hero-portrait"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
